import { createContext } from "react";

const AllowanceContext = createContext();

export default AllowanceContext;
